module.exports = __webpack_public_path__ + "assets/img/root100_2019_logo_blackbackground_comp-1b3950aeb016a64bd1279ea0fd04ee3e.png";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/root100_2019_logo_blackbackground_comp.png
// module id = 218
// module chunks = 0